// Redirections
import { createHashHistory } from "history";
const getBasename = () => {
    return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};
export default createHashHistory({ basename: getBasename() }); 